__turbopack_context__.v({
  "back": "account-messages-module-sass-module__Jj8Tya__back",
  "btnContainer": "account-messages-module-sass-module__Jj8Tya__btnContainer",
  "chat": "account-messages-module-sass-module__Jj8Tya__chat",
  "chatHeader": "account-messages-module-sass-module__Jj8Tya__chatHeader",
  "composeMsgForm": "account-messages-module-sass-module__Jj8Tya__composeMsgForm",
  "content": "account-messages-module-sass-module__Jj8Tya__content",
  "delete": "account-messages-module-sass-module__Jj8Tya__delete" + " " + __turbopack_context__.i(170233)["delete"],
  "fromDiv": "account-messages-module-sass-module__Jj8Tya__fromDiv",
  "isStarred": "account-messages-module-sass-module__Jj8Tya__isStarred",
  "message": "account-messages-module-sass-module__Jj8Tya__message",
  "messageSentOverlay": "account-messages-module-sass-module__Jj8Tya__messageSentOverlay",
  "messageSentText": "account-messages-module-sass-module__Jj8Tya__messageSentText",
  "messages": "account-messages-module-sass-module__Jj8Tya__messages",
  "messagingTemporarilyDisabledMsg": "account-messages-module-sass-module__Jj8Tya__messagingTemporarilyDisabledMsg",
  "noMessage": "account-messages-module-sass-module__Jj8Tya__noMessage",
  "starred": "account-messages-module-sass-module__Jj8Tya__starred" + " " + __turbopack_context__.i(170233)["starred"],
});
